<template>
  <div v-if="Object.values(protocolo).length">
    <sub-header-grey class="pt-1 pb-1">
      <div class="row">
        <div class="col">
          <h4>NR. {{ protocolo.numero }}/{{ protocolo.ano }} - {{ getStatus(protocolo.status) }}</h4>
        </div>
        <div class="col text-right">
          <button class="btn btn-sm btn-danger"
                  @click="deleteProtocolo()">
            Excluir protocolo
          </button>
          <button class="btn btn-sm btn-primary ml-2"
                  @click="modalProtocolo.show = true">
            Editar protocolo
          </button>
        </div>
      </div>
    </sub-header-grey>
    <div class="row mt-2">
      <div class="col">
        <div v-for="(parte, parteIndex) in protocolo.partes"
             :key="`partes_${ _uid }_${ parteIndex }`"
             class="row">
          <div class="col-2">
            <b>Requerente nome:</b><br>
            <span>{{ parte.nome }}</span>
          </div>
          <div v-if="parte.cpf"
               class="col-2">
            <b>Requerente CPF:</b><br>
            <span>{{ parte.cpf | cpf }}</span>
          </div>
          <div class="col-2">
            <b>Data protocolo:</b><br>
            <span>{{ protocolo.data_protocolo | date }}</span>
          </div>
          <div v-if="protocolo.status == 'CUMPRIDO'"
               class="col">
            <b>Data cumprimento:</b><br>
            <span>{{ protocolo.data_cumprimento | date }}</span>
          </div>
          <div v-if="protocolo.status == 'CANCELADO'"
               class="col">
            <b>Data cancelamento:</b><br>
            <span>{{ protocolo.data_cancelamento | date }}</span>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-2">
            <b>Natureza:</b><br>
            <span>{{ protocolo.natureza }}</span>
          </div>
          <div class="col">
            <b>Matrícula:</b><br>
            <span v-if="protocolo.informacoes.length">
              <span v-for="(info, infoIndex) in protocolo.informacoes"
                    :key="`informacoes_${ _uid }_${ infoIndex }`">
                <span v-if="!protocolo.registro">
                  {{ info.valor | maskMatricula }}
                </span>
                <b-link v-else
                        v-b-tooltip.hover.right="'Ir para registro'"
                        target="_blank"
                        :to="getUrl(protocolo.registro)">
                  <span class="mr-2">{{ info.valor | maskMatricula }}</span>
                </b-link>
              </span>
            </span>
            <span v-else>
              Não Informado
            </span>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-6">
            <b>Observação:</b><br>
            <span class="text-justify">{{ protocolo.observacao }}</span>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col text-right">
            <button class="btn btn-sm btn-secondary"
                    @click="showModalLog()">
              <icon-svg icon="add"
                        class="icon-add icon--xs icons--white mr-1" />
              Novo andamento
            </button>
          </div>
        </div>
        <b-table :fields="table.fields"
                 :items="protocolo.logs"
                 outlined
                 striped
                 :busy="table.busy"
                 class="text-center mt-2"
                 thead-class="Protocolos_table--header"
                 tbody-tr-class="thead-row-class"
                 show-empty>
          <template #row-details="data">
            <div class="text-left">
              <b-card style="width: 70%">
                <b>Observação:</b><br>
                <protocolo-observacao :prop-log="data.item" />
              </b-card>
            </div>
          </template>
          <template #table-busy>
            <div class="text-center text-info my-2">
              <b-spinner class="align-middle mr-2 icon--sm" />

              <strong>Carregando...</strong>
            </div>
          </template>
          <template v-slot:empty="scope">
            <div class="text-center">
              Sem registros
            </div>
          </template>
          <template slot="key_data_log"
                    slot-scope="data">
            <div class="text-center">
              {{ data.item.data_log | dateHour }}
            </div>
          </template>
          <template slot="key_acoes"
                    slot-scope="data">
            <div class="text-right">
              <span v-if="!data.item.automatico"
                    class="text-center">
                <button class="btn btn-sm btn-outline-danger mr-2"
                        @click="deleteLog(data.item)">
                  Excluir
                </button>
              </span>
              <span>
                <button v-if="!data.item.automatico"
                        class="btn btn-sm btn-outline-primary mr-2"
                        @click="editLog(data.item)">
                  Editar
                </button>
              </span>
              <span>
                <button v-if="!!data.item.observacao"
                        class="btn btn-sm btn-info active"
                        @click="data.toggleDetails">
                  {{ !data.detailsShowing ? 'Mostrar': 'Esconder' }} detalhes
                </button>
              </span>
            </div>
          </template>
        </b-table>
      </div>
    </div>
    <hr class="hr-secondary">
    <div class="row">
      <div class="col text-right">
        <b-link v-if="verifyHistory()"
                class="btn btn-sm btn-outline-secondary"
                @click="backHistory()">
          Voltar
        </b-link>
        <b-link v-else
                class="btn btn-sm btn-outline-secondary"
                :to="{ name: 'protocolos' }">
          Voltar
        </b-link>
      </div>
    </div>

    <!-- protocolo log form -->
    <protocolo-log-form v-if="modalLog.show"
                        :prop-log="modalLog.log"
                        @onSaveProtocolo="(log) => saveLog(log)"
                        @onSaveLog="log => saveLog(log)"
                        @onCloseModal="closeModalLog()" />


    <!-- protocolo form -->
    <protocolo-form v-if="modalProtocolo.show"
                    :prop-protocolo="protocolo"
                    @onSaveProtocolo="(protocolo) => editProtocolo(protocolo)"
                    @onCloseModal="modalProtocolo.show = false" />
  </div>
</template>

<script>
  /* components */
  import SubHeaderGrey from "@/components/SofiaRei/Headers/SubHeaderGrey"
  import ProtocoloLogForm from "@/components/SofiaRei/Protocolos/ProtocoloLogForm"
  import ProtocoloForm from "@/components/SofiaRei/Protocolos/ProtocoloForm"
  import ProtocoloObservacao from "@/components/SofiaRei/Protocolos/ProtocoloObservacao"

  /* services */
  import ProtocolosService from "@/services/Protocolos"
  import ProtocolosLogService from "@/services/Protocolos/ProtocolosLogService"

  export default {
    name: "ProtocolosDetalhes",
    components: {
      SubHeaderGrey,
      ProtocoloLogForm,
      ProtocoloForm,
      ProtocoloObservacao
    },
    props: {
      propProtocolo: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        modalLog: {
          show: false,
          log: {}
        },
        modalProtocolo: {
          show: false
        },
        protocolo: {},
        table: {
          busy: false,
          fields: [
            {
              key: 'id',
              label: '#ID',
              sortable: false
            },
            {
              key: 'key_data_log',
              label: 'Data andamento',
              sortable: false
            },
            {
              key: 'responsavel',
              label: 'Responsavel',
              sortable: false
            },
            {
              key: 'status',
              label: 'Status',
              sortable: false
            },
            {
              key: 'key_acoes',
              label: 'Ação',
              sortable: false
            }
          ]
        },
      }
    },
    created () {
      this.init()
    },
    methods: {
      async init (jump = false) {
        try {
          loader({ active: true, text: 'Carregando protocolo...' })
          const { params } = this.$route
          if (Object.values(this.propProtocolo).length > 0 && !jump) {
            this.protocolo = { ...this.propProtocolo }
          } else {
            this.protocolo = await ProtocolosService.show(params.id)
          }
        } finally {
          loader({ active: false, text: '' })
        }
      },
      showModalLog () {
        this.modalLog.log = {}
        this.modalLog.show = true
      },
      closeModalLog () {
        this.modalLog.show = false
        this.modalLog.log = {}
      },
      async saveLog (log) {
        try {
          loader({ active: true, text: 'Salvando andamento...' })

          if (!log.id) {
            await ProtocolosLogService.store(log)
          } else {
            await ProtocolosLogService.update(log.id, log)
          }

          objSwal.success.title = 'Salvo com sucesso!'
          objSwal.success.text = ''
          this.init(true)
          Swal.fire(objSwal.success)
          this.closeModalLog()
        } catch (e) {
          objSwal.success.title = 'Erro ao salvar andamento...'
          console.error(e)
        } finally {
          loader({ active: false, text: '' })
        }
      },
      async deleteLog (log) {
        try {
          objSwal.question.title = `Atenção!`
          objSwal.question.text = `Deseja excluir o andamento #${ log.id }?`
          const status = await Swal.fire(objSwal.question)

          if (status.value) {
            loader({ active: true,  text: 'Apagando andamento...' })
            await ProtocolosLogService.delete(log)
            objSwal.success.title = 'Excluído com sucesso!'
            objSwal.success.text = ''
            Swal.fire(objSwal.success)
            this.init(true)
          }
        } finally {
          loader({ active: false })
        }
      },
      getStatus (status) {
        const obj = {
          'EM_ANDAMENTO': 'Em andamento',
          'CUMPRIDO': 'Cumprido',
          'CANCELADO': 'Cancelado'
        }

        return obj[status]
      },
      async editLog (log) {
        this.modalLog.log = log
        this.modalLog.show = true
      },
      async deleteProtocolo () {
        try {
          objSwal.question.title = `Atenção!`
          objSwal.question.text = `Deseja excluir o protocolo ${ this.protocolo.numero }?`
          const status = await Swal.fire(objSwal.question)

          // confirme a exclusão
          if (status.value) {
            loader({ active: true, text: 'Excluindo protocolo...' })
            await ProtocolosService.delete(this.protocolo.id)
            objSwal.success.title = 'Protocolo excluido!'
            Swal.fire(objSwal.success)
            this.$router.push({ name: 'protocolos' })
          }
        } finally {
          loader({ active: false, text: '' })
        }
      },
      async editProtocolo (protocolo) {
        try {
          loader({ active: true, text: 'Salvando protocolo...' })
          this.modalProtocolo.show = false
          const protocoloSave = await ProtocolosService.update(protocolo.id, protocolo)

          objSwal.success.title = `Protocolo "${ protocoloSave.numero }" atualizado!`
          Swal.fire(objSwal.success)
          this.init(true)
        } catch (e) {
          objSwal.error.title = 'Erro!'
          if (e.response.data &&  e.response.data.message) {
            if (e.response.data.message.match(/.*protocolo_usuario_id_numero_ano_unique.*/)) {
              const duplicate = e.response.data.message.match(/Duplicate entry (.*)/)[1]
              const numero = duplicate.split(' ')[0].replace(/'/g,'').split('-')
              objSwal.error.text = `Já existe um protocolo com o número ${ numero[1] } para o ano ${ numero[2] }`
            } else {
              objSwal.error.text = (e.response.data &&  e.response.data.message)
            }
          } else {
            objSwal.error.text = 'Houve um erro ao editar o protocolo, tente novamente.'
          }
          Swal.fire(objSwal.error)
          console.error(e)
        } finally {
          loader({ active: false, text: '' })
        }
      },
      getUrl (registro) {
        let url = null

        switch (registro.tipo_registro) {
        case 'C': case 'CR':
          url = { name: 'resumo_casamento', params: { id: registro.casamento.casamento_id } }
          break
        case 'D':
          url = { name: 'resumo_habilitacao_casamento', params: { id: registro.habilitacaoCasamento.habilitacao_casamento_id } }
          break
        case 'O': case 'NT':
          url = { name: 'resumo_obito', params: { id: registro.obito.obito_id } }
          break
        case 'N':
          url = { name: 'resumo_nascimento', params: { id: registro.nascimento.nascimento_id } }
          break
        }

        return url
      },
      backHistory () {
        window.history.back()
      },
      verifyHistory () {
        return window.history.length > 1
      }
    }
  }
</script>

<style scoped>

</style>
